export default __webpack_public_path__ + "files/82c53ca565ed83a033dfb4284740873d.png";